import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { ZefFormBase } from '@zerops/zef/forms';
import { PasswordChangeFormState } from './password-change.form';
import { PasswordChangeFormTranslations } from './password-change-form.translations';

@Component({
  selector: 'z-password-change-form',
  templateUrl: './password-change-form.component.html',
  styleUrls: [ './password-change-form.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordChangeFormComponent extends ZefFormBase<PasswordChangeFormState> {
  @Input()
  translations: PasswordChangeFormTranslations;

  @Input()
  passwordIsSet = true;
}
